import React, { useEffect } from 'react';
import './Modal.css';

function Modal({ open, onClose, children, title }) {
  useEffect(
    function () {
      if (open) {
        document.body.style.overflow = 'hidden';
      }
      return function () {
        document.body.style.overflow = '';
      };
    },
    [open]
  );

  if (!open) return null;

  function handleBackdropClick(e) {
    if (e.target === e.currentTarget) {
      onClose();
    }
  }

  return (
    <div
      className="ui-modal-backdrop"
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby={title ? 'ui-modal-title' : undefined}
    >
      <div className="ui-modal-box" onClick={function (e) { e.stopPropagation(); }}>
        {title && (
          <h2 id="ui-modal-title" className="ui-modal-title">
            {title}
          </h2>
        )}
        <div className="ui-modal-content">{children}</div>
      </div>
    </div>
  );
}

export default Modal;
